import * as actionTypes from "../actionTypes";
import { proceed_val_type } from "./order";

export const initialState: {
  pageCount: proceed_val_type;
} = {
  pageCount: 0
};

const reducer = (
  state = initialState,
  action: { type: string; payload?: any }
): typeof initialState => {
  switch (action.type) {
    case actionTypes.SET_PAGE_COUNT: {
      return {
        ...state,
        pageCount: action.payload
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
